import { Draft } from '~/composer/composer/entities/Draft';
import BaseValidator from '~/composer/composer/lib/validation/BaseValidator';
import PinterestValidator from '~/composer/composer/lib/validation/PinterestValidator';
import InstagramValidator from '~/composer/composer/lib/validation/InstagramValidator';
import GoogleBusinessValidator from '~/composer/composer/lib/validation/GoogleBusinessValidator';
import TwitterValidator from '~/composer/composer/lib/validation/TwitterValidator';
import FacebookValidator from '~/composer/composer/lib/validation/FacebookValidator';
import LinkedInValidator from '~/composer/composer/lib/validation/LinkedInValidator';
import TiktokValidator from '~/composer/composer/lib/validation/TiktokValidator';
import YoutubeValidator from '~/composer/composer/lib/validation/YoutubeValidator';
import MastodonValidator from './MastodonValidator';

const getValidator = (
  draft: Draft,
  isDraft: boolean,
  activeThreadId = 0
): BaseValidator => {
  let validator: BaseValidator;

  if (draft.service.isPinterest()) {
    validator = new PinterestValidator(draft, isDraft);
  } else if (draft.service.isInstagram()) {
    validator = new InstagramValidator(draft, isDraft);
  } else if (draft.service.isGoogleBusiness()) {
    validator = new GoogleBusinessValidator(draft, isDraft);
  } else if (draft.service.isTwitter()) {
    validator = new TwitterValidator(draft, isDraft, activeThreadId);
  } else if (draft.service.isFacebook()) {
    validator = new FacebookValidator(draft, isDraft);
  } else if (draft.service.isLinkedin()) {
    validator = new LinkedInValidator(draft, isDraft);
  } else if (draft.service.isTiktok()) {
    validator = new TiktokValidator(draft, isDraft);
  } else if (draft.service.isMastodon()) {
    validator = new MastodonValidator(draft, isDraft);
  } else if (draft.service.isYoutube()) {
    validator = new YoutubeValidator(draft, isDraft);
  } else {
    validator = new BaseValidator(draft, isDraft);
  }

  return validator;
};

const validate = (
  draft: Draft,
  isDraft: boolean,
  activeThreadId = 0
): string[] => {
  const validator = getValidator(draft, isDraft, activeThreadId);
  const validationResults = validator.validate();
  return validationResults.getErrorMessages() || [];
};

export { validate, getValidator };
